const ChatClientConnectionStatus = {
  pending: 'pending',
  connecting: 'connecting',
  connected: 'connected',
  connectionError: 'connectionError',
};

export default ChatClientConnectionStatus;
